import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";

const { Caps } = typography;
const { ACCENT_SECONDARY_LIGHTEST, NOTICE_LIGHT } = colors;

export const Container = styled.div`
  background-color: ${ACCENT_SECONDARY_LIGHTEST};
  border: 1px solid ${NOTICE_LIGHT};
  height: 24px;
  padding: 4px 14px;
  position: relative;
  text-align: center;
  transform: skew(16deg);

  &::before,
  &::after {
    background-color: ${ACCENT_SECONDARY_LIGHTEST};
    content: "";
    height: calc(50% + 1px);
    position: absolute;
    transform: skew(-32deg);
    width: 10px;
  }

  &::before {
    border-bottom: 1px solid ${NOTICE_LIGHT};
    border-left: 1px solid ${NOTICE_LIGHT};
    bottom: -1px;
    left: -4.5px;
  }

  &::after {
    border-right: 1px solid ${NOTICE_LIGHT};
    border-top: 1px solid ${NOTICE_LIGHT};
    right: -4.5px;
    top: -1px;
  }
`;

export const Text = styled(Caps)`
  transform: skew(-16deg);
  white-space: nowrap;
`;
